import Contact from "@/components/site/Contact";

export default function ContactPage() {
  return <Contact />;
}
